var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Button } from 'components/Button';
import { Icon } from 'components/Icon';
import { FormInput } from 'components/form/FormInput';
import { PublicLegalConsent } from 'components/public/PublicLegalConsent';
import { React, useState } from 'libs/react';
import { useModal } from 'components/modal/ModalStack';
import { CaptchaWidget, isCaptchaValid } from 'components/captcha/CaptchaWidget';
import './StoreEmailModal.scss';
/**
 * @component StoreEmailModal
 * @since 1.0.0
 */
export function StoreEmailModal({ captcha, language, configurationFields, onConfirm }) {
    const modal = useModal();
    const [email, setEmail] = useState('');
    const [captchaToken, setCaptchaToken] = useState(null);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [marketingOptIn, setMarketingOptIn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isCaptchaDone = isCaptchaValid(captcha, captchaToken);
    const isValid = isEmailValid && isCaptchaDone && privacyAccepted;
    const handleSubmit = () => __awaiter(this, void 0, void 0, function* () {
        if (!privacyAccepted) {
            setError(t('Please accept the privacy policy to continue.'));
            return;
        }
        setError('');
        setLoading(true);
        try {
            yield onConfirm(email, captchaToken, marketingOptIn);
            modal.dismiss();
        }
        catch (_a) {
            setError(t('An error occurred. Please try again.'));
        }
        finally {
            setLoading(false);
        }
    });
    return (React.createElement("div", { className: "store-email-modal-content" },
        React.createElement("div", { className: "store-email-modal__primary" },
            React.createElement("p", { className: "store-email-modal__description" }, t('Enter your email address to continue with your order.')),
            React.createElement(FormInput, { name: "store-modal-email", type: "email", label: t('Email address'), autocomplete: true, placeholder: t('name@example.com'), value: email, onChange: (value) => setEmail(value) })),
        React.createElement(PublicLegalConsent, { className: "store-email-modal__consent", configurationFields: configurationFields, language: language, privacyAccepted: privacyAccepted, marketingOptIn: marketingOptIn, onPrivacyAcceptedChange: setPrivacyAccepted, onMarketingOptInChange: setMarketingOptIn }),
        isEmailValid && (React.createElement(CaptchaWidget, { captcha: captcha, language: language, onVerify: (token) => setCaptchaToken(token) })),
        error && (React.createElement("div", { className: "store-email-modal__error", role: "alert" },
            React.createElement(Icon, { value: "circle-exclamation" }),
            React.createElement("span", null, error))),
        React.createElement("div", { className: "store-email-modal__actions" },
            React.createElement(Button, { style: "primary", size: "large", label: loading ? t('Loading…') : t('Continue'), disabled: !isValid || loading, processing: loading, onPress: handleSubmit }))));
}
